module.exports = __webpack_public_path__ + "media/images/1-off-05ff362e20703262dfce02d2601cfe0b.png";